const LOCAL_STORAGE_NAMESPACE = 'impact-ng';

const LOCAL_STORAGE_KEY_SEPARATOR = '.';

export const buildImpactLocalstorageKey = (...keys: [string, ...string[]]) =>
    [LOCAL_STORAGE_NAMESPACE, ...keys].join(LOCAL_STORAGE_KEY_SEPARATOR);
